import { TranslateService } from 'shared';

export class AgGridUserGroupRolesSettings {

  constructor(private translate: TranslateService) { }

  public agGridUserGroupRolesSettings = {
    rowModelType: 'infinite' as any,
    //virtualPaging: true,
    //enableServerSideSorting: true,
    //enableServerSideFilter: true,
    rowSelection: { mode: 'singleRow', checkboxes: false } as any,
    //rowDeselection: true,
    rowHeight: 35,
    cacheBlockSize: 10000,
    cacheOverflowSize: 2,
    maxConcurrentDatasourceRequests: 1,
    paginationPageSize: 30,
    infiniteInitialRowCount: 1,
    columnDefs: [
      { field: 'userName', headerName: `${this.translate.data["GROUPROLEUSERSCOLUMNHEADER"]}`, cellStyle: { color: '#303f6f' }, sortable: true, filter: true },
      {
        headerName: `${this.translate.data["GROUPROLEACTIONSCOLUMNHEADER"]}`,
        cellStyle: { color: '#303f6f' },
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          icon_delete: 'delete'
        }
      },
    ],
    defaultColDef: {
      flex: 1,
      resizable: true,
      minWidth: 100,
      editable: false
    }
  }
}